// DEPENDENCIES
import React from 'react';
import {Router, Route, IndexRoute} from 'react-router';

// COMPONENTS
import App from './App';
import { Pages } from './Pages';
import { MainContainer } from './Components/Main';
import { UserPanelContainer } from './Components/UserPanel';
import { Packages } from './Components/Modals/Packages';
import { ForgotPassword } from './Components/Screens/ForgotPassword';
import {
    AdminUsers,
    Events,
    Services,
    Musicians,
    Bands,
    Categories,
    Banner,
    AdminPackages,
    Transactions,
    Settings
} from './Components/Screens/Admin';

const Routes = (props) => (
    <Router {...props}>
        <Route path="/pages/:id" component={Pages} {...props}/>
        <Route path="/" component={App} structType={1} >
            <IndexRoute component={MainContainer} {...props}/>
            <Route path="/user-panel" component={UserPanelContainer} {...props}/>
            <Route path="/packages" component={Packages} {...props}/>
        </Route>
        <Route component={App} structType={2} >
            <Route path="/forgot-password" component={ForgotPassword} {...props} />
            <Route path="/change-password/:token" component={ForgotPassword} {...props} />
        </Route>
        <Route path="/olimpus" component={App} structType={3}>
            <Route path="users" component={AdminUsers} {...props}/>
            <Route path="music-events" component={Events} {...props}/>
            <Route path="music-services" component={Services} {...props}/>
            <Route path="music-musicians" component={Musicians} {...props}/>
            <Route path="music-bands" component={Bands} {...props}/>
            <Route path="music-categories" component={Categories} {...props}/>
            <Route path="packages" component={AdminPackages} {...props}/>
            <Route path="banner-selection" component={Banner} {...props}/>
            <Route path="transactions" component={Transactions} {...props}/>
            <Route path="music-settings" component={Settings} {...props}/>
        </Route>
    </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js